import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'
// import getters from './getters'

Vue.use(Vuex)
const state = {
  userInfo: {},
  panoUploadList: [],
  taskUploadList: {},
  newPanoCount: 0,
  newModel: {
    newModelCount: 0,
    newProcessType: null
  },
  isCreateNewPano: false,
  panoDialogData: {},
  panoUploadDatas: [], // 所有打开过素材弹窗的任务，无序任务保存时获取任务的素材列表
  uploadListStatus: 'stop',
  modelUploadListStatus: 'stop',
  modelUploadList: []
}

export default new Vuex.Store({
  state,
  mutations,
  actions
  // getters
})



// WEBPACK FOOTER //
// ./src/vuex/store.js